<template lang="pug">
	.login
		el-card.login-form(style="position: relative; top: 60px;")
			h2 Авторизация
			el-form.login-form(:model="data" :rules="rules" ref="authForm" @submit.native.prevent="login")
				el-form-item(prop="name")
					el-input(v-model="data.name" placeholder="Имя пользователя" prefix-icon="fas fa-user")
				el-form-item(prop="password")
					el-input(v-model="data.password" placeholder="Пароль" type="password" prefix-icon="fas fa-lock" show-password)
				el-form-item
					el-button.login-button(:loading="isLoading" :disabled="isLoading" type="primary" native-type="submit" block="") Войти

</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { AUTH_LOGIN } from '@/store/const/user';

import instruments from '@/mixins/instruments';

export default {
  name: 'LoginPage',
  mixins: [instruments],
  data() {
    return {
      data: {
        name: '',
        password: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Имя пользователя обязательно',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: 'Вы не ввели пароль',
            trigger: 'blur',
          },
        ],
      },
      browserInfo: {
        width: window.innerWidth,
        height: window.innerHeight,
        screen: window.screen,
      },
    };
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('user', [
      'username',
    ]),
    isLoading() {
      return this.loading(AUTH_LOGIN) === 'loading';
    },
  },
  methods: {
    ...mapActions('user', {
      loginRequest: AUTH_LOGIN,
    }),
    getBrowserInfo() {
      var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    },
    getOsInfo() {
      var OSName = 'Unknown OS';
      if (navigator.appVersion.indexOf('Win') != -1) OSName = 'Windows';
      if (navigator.appVersion.indexOf('Mac') != -1) OSName = 'MacOS';
      if (navigator.appVersion.indexOf('X11') != -1) OSName = 'UNIX';
      if (navigator.appVersion.indexOf('Linux') != -1) OSName = 'Linux';
      return OSName;
    },
    async login() {
      try {
        const data = {
          browser: {
            main: this.browserInfo,
            advanced: this.getBrowserInfo(),
          },
          os: this.getOsInfo(),
        };
        await this.$refs.authForm.validate();
        const request = await this.loginRequest({
          name: this.data.name,
          password: this.data.password,
          data,
        });
        await this.notifyRequestResult({
          request,
          successMessage: `Добро пожаловать, ${this.username}!`,
        });
      } catch (e) {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.login-form {
  margin: 0 auto;
  max-width: 500px;
}
</style>
